import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-newbuilding-call-component';

import { useApplicationContext } from '../../utils/applicationContext';
import { cropPhone } from '../../utils/businessLogic/phone';
import { INewbuildingSeller } from '../../types/newbuilding/seller';

import * as styles from './CallSeller.css';
import { formatPhone } from './utils/formatPhone';

export interface ICallSellerProps {
  dynamicCalltrackingPlaceType: string;
  target: INewbuildingSeller;
  trackActionOpenContactsCall(builder: INewbuildingSeller): void;
}

export const CallSeller = ({ target, dynamicCalltrackingPlaceType, trackActionOpenContactsCall }: ICallSellerProps) => {
  const [open, setOpen] = React.useState(false);
  const [dynamicPhone, setDynamicPhone] = React.useState('');
  const { httpApi, logger } = useApplicationContext();

  const handleClick = React.useCallback(async () => {
    let dynamicPhone = null;
    const blockId = target.dynamicCalltracking?.siteBlockId ?? null;

    if (blockId) {
      const response = await handleDynamicCalltracking({
        logger,
        httpApi,
        blockId,
        platformType: EPlatformTypes.WebDesktop,
        pageType: EPageTypes.NewbuildingCard,
        placeType: dynamicCalltrackingPlaceType,
      });

      dynamicPhone = formatPhone(response.notFormattedPhone);
    }

    setOpen(true);
    trackActionOpenContactsCall(target);

    setDynamicPhone(dynamicPhone || cropPhone({ phone: target.phone, isFullPhone: true }));
  }, [httpApi, logger, target, dynamicCalltrackingPlaceType, trackActionOpenContactsCall]);

  if (open) {
    return (
      <span className={styles['phone']} data-testid="CallSellerPhone">
        {dynamicPhone}
      </span>
    );
  }

  return (
    <Button onClick={handleClick} theme="fill_secondary" size="XS" data-testid="CallSellerButton">
      Контакты представителя
    </Button>
  );
};
